import React from "react";
import "./PdfTextBox.css";

class PdfTextBox extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClicked = this.handleClicked.bind(this);
    this.handleRightClicked = this.handleRightClicked.bind(this);
    this.delayClicked = getClickHandler(this.handleClicked);

    this.state = {
      isHovering: false
    };
  }

  handleMouseEnter() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleClicked(e) {
    const { textBox, handleClicked } = this.props;
    handleClicked(textBox);
  }

  handleRightClicked(e) {
    e.preventDefault();

    const { textBox, handleRightClicked } = this.props;
    handleRightClicked(textBox);
  }

  render() {
    const {
      textBox,
      width,
      height,
      selected,
      isSelecting,
      previewing,
      invisible,
      highlight,
      displayMode,
      warning
    } = this.props;
    const { isHovering } = this.state;

    if (textBox == null || width <= 0 || height <= 0) {
      return null;
    }

    const { x, y, w, h } = textBox;

    let divStyle = {
      left: `${(x * 100) / width}%`,
      width: `${(w * 100) / width}%`,
      top: `${(y * 100) / height}%`,
      height: `${(h * 100) / height}%`
    };

    const focusClassName =
      textBox.tagID == null
        ? "pdf_text_box_border_focus"
        : "pdf_text_box_border_focus_tag";
    const nomralClassName =
      textBox.tagID == null ? "pdf_text_box_border" : "pdf_text_box_border_tag";

    let className = nomralClassName;

    if (previewing) {
      className = "pdf_text_box_border_previewing";
    } else if ((!isSelecting && isHovering) || selected) {
      className = focusClassName;
    } else if (highlight && warning) {
      className = "pdf_text_box_border_warning";
    } else if (highlight) {
      className = focusClassName;
    } else if (displayMode) {
      className = "pdf_text_box_border_none";
    } else if (invisible) {
      className = "pdf_text_box_border_hide";
    } else if (warning) {
      className = "pdf_text_box_border_warning";
    }

    return (
      <div
        className={className}
        style={divStyle}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.delayClicked}
        onContextMenu={this.handleRightClicked}
      />
    );
  }
}

function getClickHandler(onClick) {
  let timeoutID = null;
  const delay = 250;

  return function(event) {
    if (!timeoutID) {
      timeoutID = setTimeout(function() {
        onClick(event);
        timeoutID = null;
      }, delay);
    } else {
      clearTimeout(timeoutID);
      timeoutID = null;
    }
  };
}

export default PdfTextBox;
